<template>
<v-layout
    fluid
    fill-height
    column
    class="pa-0 ma-0 script-wrapper"
    fill-width
  >
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
  
  </v-layout>
</template>

<script>
import routes from '@/route_names'
export default {
  name: 'ScriptView',
  
}
</script>

<style lang="stylus" >
.script-wrapper {
    width 100%
}
</style>
